<template lang="pug">
.parametros-fornecedor-formulario
    BaseHeader(
        :titulo='$t("configuracaoParametros.formulario.titulo.fornecedor")',
        voltarPara
    )
    .parametros-fornecedor-formulario__container
        el-form.parametros-fornecedor-formulario__form(
            label-position='top',
            size='default',
            :model='configuracao',
            :rules='listaRegras',
            :hide-required-asterisk='true',
            ref='parametrosFornecedorFormularioRef'
        )
            .parametros-fornecedor-formulario__titulo
                h3 {{ obterTituloFormulario() }}
            .parametros-fornecedor-formulario__card
                el-form-item.required(
                    :label='$t("configuracaoParametros.formulario.campoFornecedor")',
                    prop='idFornecedor'
                )
                    el-select(
                        v-model='configuracao.idFornecedor',
                        :placeholder='$t("configuracaoParametros.formulario.placeholderFornecedor")',
                        :clearable='false',
                        filterable
                    )
                        el-option(
                            v-for='fornecedore in fornecedores',
                            :key='fornecedore.id',
                            :label='fornecedore.nome',
                            :value='fornecedore.id'
                        )
                el-form-item(
                    :label='$t("configuracaoParametros.formulario.campoDistanciaRaioKm")',
                    prop='distanciaRaioKm'
                )
                    el-input(
                        type='number',
                        v-model='configuracao.distanciaRaioKm',
                        :placeholder='$t("configuracaoParametros.formulario.placeholderDistanciaRaioKm")',
                        @keydown='handleKeydownInputNumber'
                    )
                el-form-item(
                    :label='$t("configuracaoParametros.formulario.campoPorExcCapProdutiva")',
                    prop='percentualCapacidadeProdutiva'
                )
                    el-input(
                        type='number',
                        v-model='configuracao.percentualCapacidadeProdutiva',
                        :placeholder='$t("configuracaoParametros.formulario.placeholderCampoPorExcCapProdutiva")',
                        disabled,
                        @keydown='handleKeydownInputNumber'
                    )
                el-form-item
                    el-button.el-button--add(@click='adicionarExcecaoEstado')
                        i.el-icon-plus
                        span {{ $t('configuracaoParametros.formulario.butaoAdicionarExcecao') }}

            .parametros-fornecedor-formulario__titulo(
                v-if='configuracao.excecoes.length'
            )
                h3 {{ $t('configuracaoParametros.formulario.tituloExecoes') }}
            .parametros-fornecedor-formulario__card(
                v-for='(excecao, index) in configuracao.excecoes',
                :key='`fornecedor-excecao-${index}`'
            )
                .parametros-fornecedor-formulario__row
                    el-form-item.required(
                        :label='$t("configuracaoParametros.formulario.campoEstado")',
                        :prop='`idEstado${index}`'
                    )
                        el-select(
                            v-model='excecao.idEstado',
                            :disabled='!!excecao.idEstado',
                            :placeholder='$t("configuracaoParametros.formulario.placeholderEstado")',
                            :clearable='false',
                            filterable
                        )
                            el-option(
                                v-for='estado in listaEstado',
                                :disabled='estado.selecionado',
                                :key='estado.id',
                                :label='estado.nome',
                                :value='estado.id'
                            )
                    .remove-excecao(@click='removerExcecaoEstado(index)')
                        i.el-icon-delete

                el-form-item(
                    :label='$t("configuracaoParametros.formulario.campoTipoExececao")'
                )
                    el-select(
                        v-model='excecao.aplicarTodoEstado',
                        :placeholder='$t("configuracaoParametros.formulario.placeholderTipoExececao")',
                        :clearable='false',
                        filterable,
                        @change='adicionarRegraTipoExcecao(excecao.aplicarTodoEstado, index)'
                    )
                        el-option(
                            v-for='tipo of tiposExececao',
                            :key='`tipo-exececeao-${index}-${tipo.id}`',
                            :label='tipo.label',
                            :value='tipo.value'
                        )
                el-form-item(
                    v-if='!excecao.aplicarTodoEstado',
                    :label='$t("configuracaoParametros.formulario.campoDistanciaRaioKm")',
                    :prop='`distanciaRaioKm${index}`'
                )
                    el-input(
                        type='number',
                        v-model='excecao.distanciaRaioKm',
                        filterable,
                        :placeholder='$t("configuracaoParametros.formulario.placeholderDistanciaRaioKm")',
                        @keydown='handleKeydownInputNumber'
                    )
                el-form-item(
                    :label='$t("configuracaoParametros.formulario.campoPorExcCapProdutiva")',
                    :prop='`percentualCapacidadeProdutiva${index}`'
                )
                    el-input(
                        type='number',
                        v-model='excecao.percentualCapacidadeProdutiva',
                        :placeholder='$t("configuracaoParametros.formulario.placeholderCampoPorExcCapProdutiva")',
                        disabled,
                        @keydown='handleKeydownInputNumber'
                    )

                el-form-item
                    el-checkbox(
                        v-model='excecao.naoTemExcecaoMunicipio',
                        @change='manipularExcecaoMunicipio(index, excecao.idEstado)',
                        :disabled='!excecao.idEstado'
                    ) {{ $t('configuracaoParametros.formulario.checkboxNaoUtilizarExececaoMunicipio') }}

                .parametros-fornecedor-formulario__excecao-municipio(
                    v-if='!excecao.naoTemExcecaoMunicipio',
                    v-for='(excecaoMunicipio, indexMunicipio) in excecao.excecoes',
                    :key='`excecao-municipio-${indexMunicipio}`'
                )
                    .parametros-fornecedor-formulario__row
                        el-form-item.required(
                            :label='$t("configuracaoParametros.formulario.campoMunicipio")',
                            :prop='`idMunicipio${index}${indexMunicipio}`'
                        )
                            el-select(
                                v-model='excecaoMunicipio.idMunicipio',
                                :placeholder='$t("configuracaoParametros.formulario.placeholderMunicipio")',
                                :clearable='false',
                                filterable
                            )
                                el-option(
                                    v-for='municipio in listaMunicipios(index) || []',
                                    :disabled='municipio.selecionado',
                                    :key='municipio.id',
                                    :label='municipio.nome',
                                    :value='municipio.id'
                                )
                        .remove-excecao(
                            @click='removerExcecaoMunicipio(index, indexMunicipio)'
                        )
                            i.el-icon-delete
                    el-form-item(
                        :label='$t("configuracaoParametros.formulario.campoDistanciaRaioKm")',
                        :prop='`distanciaRaioKm${index}${indexMunicipio}`'
                    )
                        el-input(
                            type='number',
                            v-model='excecaoMunicipio.distanciaRaioKm',
                            :placeholder='$t("configuracaoParametros.formulario.placeholderDistanciaRaioKm")',
                            @keydown='handleKeydownInputNumber'
                        )
                    el-form-item(
                        :label='$t("configuracaoParametros.formulario.campoPorExcCapProdutiva")',
                        :prop='`percentualCapacidadeProdutiva${index}${indexMunicipio}`'
                    )
                        el-input(
                            type='number',
                            v-model='excecaoMunicipio.percentualCapacidadeProdutiva',
                            :placeholder='$t("configuracaoParametros.formulario.placeholderCampoPorExcCapProdutiva")',
                            disabled,
                            @keydown='handleKeydownInputNumber'
                        )
                el-form-item(v-if='!excecao.naoTemExcecaoMunicipio')
                    el-button.el-button--add(
                        @click='adicionarExcecaoMunicipio(index)'
                    )
                        i.el-icon-plus
                        span {{ $t('configuracaoParametros.formulario.butaoAdicionarExcecaoMunicipio') }}

        .parametros-fornecedor-formulario__footer
            el-button(@click='voltarConfiguracao')
                i.mdi.mdi-arrow-left
                span {{ $t('configuracaoParametros.formulario.butaoVoltar') }}
            el-button(type='primary', @click='submeterParametros')
                span {{ $t('configuracaoParametros.formulario.butaoSalvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/services/ConfiguracaoRastreabilidadeService';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import LocalidadeService from '@/services/LocalidadeService';
import { handleKeydownInputNumber } from '@/views/contratos-originacao/parametros/utils';
import { tiposExececao } from '@/views/contratos-originacao/parametros/utils/assets/configuracaoParametros';

import {
    cadastrarParametros,
    editarParametros,
    buscarParametros
} from '@/views/contratos-originacao/parametros/services/configuracaoFornecedorService';
import {
    regras,
    regrasExececoes
} from '@/views/contratos-originacao/parametros/utils/assets/regrasFormularioFornecedor';

export default {
    name: 'ParametrosFornecedorFormulario',
    components: {
        BaseHeader: () => import('@/components/BaseHeader')
    },
    data() {
        return {
            regras,
            tiposExececao,
            fornecedores: [],
            estados: [],
            municipios: [],
            configuracao: {
                id: null,
                idFornecedor: null,
                distanciaRaioKm: null,
                percentualCapacidadeProdutiva: 15,
                excecoes: []
            }
        };
    },
    mounted() {
        this.buscarDados();
        this.buscarEstados();
        this.buscarFornecedores();
    },
    computed: {
        formRef() {
            return this.$refs.parametrosFornecedorFormularioRef;
        },
        listaEstado() {
            return this.estados.map(({ nome, id }) => ({
                nome,
                id,
                selecionado: this.configuracao.excecoes?.some(
                    excecao => excecao.idEstado === id
                )
            }));
        },
        listaRegras() {
            return this.configuracao.excecoes.reduce(
                (acc, excecao, index) => {
                    Object.keys(regrasExececoes).forEach(regra => {
                        acc[regra + index] = [
                            {
                                ...regrasExececoes[regra],
                                validator: this.validator(
                                    excecao[regra],
                                    regrasExececoes[regra][0].message
                                )
                            }
                        ];
                    });

                    if (excecao.excecoes?.length) {
                        excecao.excecoes.forEach(
                            (municipio, municipioIndex) => {
                                Object.keys(regrasExececoes).forEach(regra => {
                                    acc[regra + index + municipioIndex] = [
                                        {
                                            ...regrasExececoes[regra],
                                            validator: this.validator(
                                                municipio[regra],
                                                regrasExececoes[regra][0]
                                                    .message
                                            )
                                        }
                                    ];
                                });
                            }
                        );
                    }

                    return acc;
                },
                { ...regras }
            );
        }
    },
    methods: {
        handleKeydownInputNumber,
        adicionarExcecaoEstado() {
            const temFornecedor = this.configuracao.idFornecedor;
            const temEstadoNaoSelecionado = this.configuracao.excecoes.some(
                excecao => !excecao.idEstado
            );
            if (
                temFornecedor &&
                (!temEstadoNaoSelecionado || !this.configuracao.excecoes.length)
            ) {
                this.configuracao.excecoes.push({
                    id: null,
                    naoTemExcecaoMunicipio: true,
                    aplicarTodoEstado: true,
                    distanciaRaioKm: null,
                    idEstado: null,
                    idMunicipio: null,
                    percentualCapacidadeProdutiva:
                        this.configuracao.percentualCapacidadeProdutiva,
                    excecoes: []
                });
            } else {
                if (!temFornecedor) {
                    return this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroAdicionarExcecaoEstado'
                        )
                    );
                }
                if (temEstadoNaoSelecionado) {
                    return this.$notify.error(
                        this.$t('configuracaoParametros.erro.campoEstadoErro')
                    );
                }
            }
        },
        removerExcecaoEstado(index) {
            this.configuracao.excecoes.splice(index, 1);
        },
        manipularExcecaoMunicipio(index, idEstado) {
            if (this.configuracao.excecoes[index].naoTemExcecaoMunicipio) {
                this.removerTodasExcecoesMunicipio(index);
            } else {
                this.adicionarExcecaoMunicipio(index, idEstado);
            }
        },
        async adicionarExcecaoMunicipio(index, idEstado = null) {
            const excecoes = this.configuracao?.excecoes[index]?.excecoes;
            const temMunicipioNaoSelecionado = excecoes?.some(
                excecao => !excecao.idMunicipio
            );
            if (idEstado) {
                await this.buscarMunicipios(idEstado, index);
            }
            if (!temMunicipioNaoSelecionado || excecoes.length === 0) {
                this.configuracao.excecoes[index].excecoes.push({
                    id: null,
                    distanciaRaioKm: null,
                    idMunicipio: null,
                    percentualCapacidadeProdutiva:
                        this.configuracao.percentualCapacidadeProdutiva
                });
            } else {
                this.$notify.error(
                    this.$t(
                        'configuracaoParametros.erro.erroAdicionarExcecaoMunicipio'
                    )
                );
            }
        },
        removerExcecaoMunicipio(indexExcecao, indexMunicipio) {
            if (
                this.configuracao.excecoes[indexExcecao].excecoes.length === 1
            ) {
                this.configuracao.excecoes[
                    indexExcecao
                ].naoTemExcecaoMunicipio = true;
            }
            this.configuracao.excecoes[indexExcecao].excecoes.splice(
                indexMunicipio,
                1
            );
        },
        removerTodasExcecoesMunicipio(index) {
            this.configuracao.excecoes[index].excecoes = [];
        },
        validator(fieldValue, message) {
            return (value, _, callback) => {
                if (fieldValue) {
                    callback();
                } else {
                    callback(new Error(message));
                }
            };
        },
        obterTituloFormulario() {
            return this.$route.params?.idConfiguracaoRastreabilidade
                ? this.$t(
                      'configuracaoParametros.formulario.tituloFormularioEdicao.fornecedor'
                  )
                : this.$t(
                      'configuracaoParametros.formulario.tituloFormularioCadastro.fornecedor'
                  );
        },
        voltarConfiguracao() {
            this.$router.push({ name: 'ParametrosFornecedor' });
        },
        buscarFornecedores() {
            ContratoOriginacaoService.buscarBpClientes()
                .then(({ data }) => {
                    this.fornecedores = data;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('mensagens.sistema.erroBuscarFornecedores')
                    );
                });
        },
        buscarEstados() {
            LocalidadeService.findEstados()
                .then(({ data }) => {
                    this.estados = data;
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t('mensagens.sistema.erroBuscarEstados')
                    );
                });
        },
        async buscarMunicipios(idEstado, indexExcecao) {
            if (idEstado) {
                const index = this.municipios.findIndex(
                    municipio => municipio.id === idEstado
                );
                if (index !== -1) {
                    this.municipios[indexExcecao] = this.municipios[index];
                    this.configuracao.excecoes[indexExcecao].municipios =
                        this.municipios[index];
                    this.$forceUpdate();
                } else {
                    await LocalidadeService.findMunicipios(idEstado)
                        .then(({ data }) => {
                            this.municipios[indexExcecao] = {
                                id: idEstado,
                                data
                            };
                            this.$forceUpdate();
                        })
                        .catch(() => {
                            this.$notify.error(
                                this.$t(
                                    'mensagens.sistema.erroBuscarMunicipios'
                                )
                            );
                        });
                }
            }
        },
        buscarConfiguracaoPadrao() {
            return services
                .buscarConfiguracaoRastreabilidadePadrao()
                .then(({ data }) => {
                    if (data) {
                        this.configuracao.distanciaRaioKm =
                            data.distanciaRaioKm;
                        this.configuracao.percentualCapacidadeProdutiva =
                            data.percentualCapacidadeProdutiva;
                    }
                })
                .catch(() => {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroBucaConfiguracaoPadrao'
                        )
                    );
                });
        },
        async buscarDados() {
            const id = this.$route.params?.idConfiguracaoRastreabilidade;
            try {
                if (id) {
                    const parametros = await buscarParametros(id);
                    parametros.excecoes.forEach(async (excecao, index) => {
                        await this.buscarMunicipios(excecao.idEstado, index);
                    });
                    this.configuracao = parametros;
                } else {
                    this.buscarConfiguracaoPadrao();
                }
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'configuracaoParametros.erro.erroBuscarConfiguracao'
                    )
                );
            }
        },
        editarParametros() {
            editarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t('configuracaoParametros.sucesso.sucessoEditarDados')
                );
                this.voltarConfiguracao();
            });
        },
        cadastrarParametros() {
            cadastrarParametros(this.configuracao).then(() => {
                this.$notify.success(
                    this.$t(
                        'configuracaoParametros.sucesso.sucessoCadastrarDados'
                    )
                );
                this.voltarConfiguracao();
            });
        },
        submeterParametros() {
            this.formRef.validate(valid => {
                if (valid) {
                    if (this.configuracao.id) {
                        this.editarParametros();
                    } else {
                        this.cadastrarParametros();
                    }
                } else {
                    this.$notify.error(
                        this.$t(
                            'configuracaoParametros.erro.erroFormularioInvalido'
                        )
                    );
                    return false;
                }
            });
        },
        listaMunicipios(index) {
            return (
                this.municipios[index]?.data?.map(({ nome, id }) => ({
                    nome,
                    id,
                    selecionado:
                        this.configuracao.excecoes[index]?.excecoes?.some(
                            excecao => excecao.idMunicipio === id
                        ) || false
                })) || []
            );
        },
        adicionarRegraTipoExcecao(value, index) {
            if (value && this.configuracao.excecoes[index]) {
                this.configuracao.excecoes[index].distanciaRaioKm = null;
            }
        }
    }
};
</script>

<style lang="scss">
.parametros-fornecedor-formulario {
    &__container {
        margin: 20px;
    }
    &__titulo {
        margin: 20px 0 12px;
    }
    &__form {
        width: 100%;
    }
    &__card {
        display: flex;
        flex-direction: column;
        padding: 20px;
        gap: 4px;
        background-color: var(--white);
        border-radius: $default-border-radius;
        @include default-box-shadow();
        & + & {
            margin-top: 20px;
        }
    }
    &__row {
        display: flex;
        gap: 16px;
    }
    &__info {
        color: var(--gray);
    }
    &__footer {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
    }
    &__excecao-municipio {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        & + & {
            margin-top: 20px;
            &::before {
                content: '';
                display: block;
                width: 50%;
                height: 1px;
                background-color: $default-border-color;
                margin: 20px 0;
            }
        }
    }
    &__add-excecao-municipio {
        margin-top: 20px;
        margin-left: 20px;
    }
    .el-form-item {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 4px;
        &.required > .el-form-item__label {
            &::after {
                content: '*';
                margin-left: 2px;
                color: red;
            }
        }

        &__label {
            line-height: 1;
        }
        .el-select {
            width: 100%;
            & input {
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
        .el-input {
            width: 100%;
            height: 42px;
            outline: none;
            border: 1px solid $default-border-color;
            border-radius: $default-border-radius;
            &:hover,
            &:focus {
                border: 1px solid $primary;
            }
            & input {
                color: var(--primary) !important;
                outline: none;
                border: none;
                &:disabled {
                    color: #545454 !important;
                }
            }
        }
    }
    .el-button {
        &--add {
            width: 300px;
            height: 40px;
            font-weight: bold;
        }
        &--primary {
            &:focus {
                color: var(--white);
            }
        }
        &--default {
            background-color: transparent;
            color: var(--primary);
            border: 1px solid var(--primary);
            &:hover {
                background-color: var(--primary);
                color: var(--white);
            }
        }
    }
    .remove-excecao {
        width: 40px;
        height: 40px;
        background-color: $background-danger;
        color: $font-danger;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: $default-border-radius;
        margin-top: 22px;
        cursor: pointer;
    }
}
</style>
